import AddIcon from '@mui/icons-material/Add';
import InfoIcon from '@mui/icons-material/Info';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { CoverageStructure } from '@/types/VacationRegister';
import VacationCoverPlanPeriod from './VacationCoverPlanPeriod';

interface Props {
	employees: { id: string; name: string }[];
	structures: CoverageStructure[] | undefined;
	index: number;
	vacationCovers?: { startDate: Date; endDate: Date }[];
}

const VacationCoverPlan = ({
	employees,
	index,
	vacationCovers,
	structures,
}: Props) => {
	const { control } = useFormContext();
	const { fields, append, remove } = useFieldArray({
		control,
		name: `vacationPeriods.${index}.vacationCovers`,
	});

	const addCoverPlan = () => {
		append({
			coverageType: '',
			name: '',
			employeeId: '',
			startDate: '',
			endDate: '',
			needTransport: false,
		});
	};

	return (
		<div className="mb-3 rounded-lg border border-[#CBD5E1] bg-white px-[16px] py-[14px]">
			<div className="flex items-center">
				<span className="mr-[0.5rem] text-[14px] font-[500] text-primary">
					Plano de cobertura
				</span>
				<InfoIcon sx={{ fontSize: 16, color: '#193CB9' }} />
			</div>
			{fields.map((el, idx) => {
				return (
					<VacationCoverPlanPeriod
						employees={employees}
						idx={idx}
						index={index}
						key={el.id}
						vacationCovers={vacationCovers}
						remove={remove}
						structures={structures}
					/>
				);
			})}
			<button
				type="button"
				className="flex items-center gap-1 text-[12px] text-[#193CB9] font-[500] pt-[16px]"
				onClick={addCoverPlan}
			>
				<AddIcon sx={{ fontSize: 16 }} />
				Adicionar plano de cobertura
			</button>
		</div>
	);
};

export default VacationCoverPlan;
